export function getPriceFontSize(styles, canvasScale, multiplier = 2) {
  const fontScale = styles.fontSize * canvasScale;
  return fontScale * multiplier;
}

export function getPriceScale(length) {
  switch (length) {
    case 4:
      return 1.1;
    case 5:
      return 0.8;
    case 6:
      return 0.5;
    case 7:
      return 0.38;
    default:
      return 0.25;
  }
}
